"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PublicPage = _interopRequireDefault(require("./components/PublicPage.vue"));
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PDDAllianceAuthorization',
  components: {
    PublicPage: _PublicPage.default
  },
  data: function data() {
    return {
      name: '多多进宝联盟',
      platformCode: 'PDD'
    };
  }
};